<div class="metadata-container" *ngIf="!!selection">
    <div class="card">
        <div class="card-block">

            <div class="form-group column col-12 w-100">
                <div class="card-text ml-1 mb-1"><b>referenceStory (Unique ID): {{selection.metaData.referenceStory}}</b></div>
                <div class="form-check">
                    <label class="form-check-label" for="isHighInterestLowLevel">
                        <input class="form-check-input mr-1" id="isHighInterestLowLevel" type="checkbox" [checked]="!!selection.metaData.isHighInterestLowLevel"
                               [(ngModel)]="selection.metaData.isHighInterestLowLevel">High Interest, Low Level</label>
                </div>

            </div>

            <div class="form-group row">
                <label for="fullTitle" class="col-form-label col-xs-3">Full Title</label>
                <div class="col-xs-9">
                    <input class="form-control" type="text" [(ngModel)]="selection.metaData.fullTitle"
                           id="fullTitle">
                </div>
            </div>

            <div class="form-group row">
                <label for="shortTitle" class="col-form-label col-xs-3">Short Title</label>
                <div class="col-xs-9">
                    <input class="form-control" type="text" [(ngModel)]="selection.metaData.shortTitle"
                           id="shortTitle">
                </div>
            </div>

            <div class="form-group row">
                <label for="seriesName" class="col-form-label col-xs-3">Series Name</label>
                <div class="col-xs-9">
                    <input class="form-control" type="text" [(ngModel)]="selection.metaData.seriesName"
                           id="seriesName">
                </div>
            </div>

            <div *ngIf="!!selection.metaData.seriesName" class="form-group row">
                <label for="orderWithinSeries" class="col-form-label col-xs-5">Order Within Series</label>
                <select id="orderWithinSeries" [(ngModel)]="selection.metaData.orderWithinSeries">
                    <option>{{dropdownDefault}}</option>
                    <option *ngFor="let in of counter(30) ;let order = index" value={{(order+1).toString()}}>
                        {{order+1}}
                    </option>
                </select>
            </div>



            <div class="form-group row">
                <label for="coverImage" class="col-form-label col-xs-5">Cover Image</label>
                <div class="col-xs-9">
                    <img *ngIf="selection.metaData.coverImage != ''" src="{{ getImageSrc(selection.metaData.coverImage) }}"/>
                    <input class="form-control" type="text" [(ngModel)]="selection.metaData.coverImage"
                           id="coverImage">
                </div>
            </div>

            <div class="form-group row">
                <label for="ATOSGradeEquivalent" class="col-form-label col-xs-5">ATOS</label>
                <div class="col-xs-3">
                    <input class="form-control" type="text" [(ngModel)]="selection.metaData.ATOSGradeEquivalent"
                    (ngModelChange)="onATOSGradeChange()" id="ATOSGradeEquivalent">
                </div>
            </div>


            <div class="form-group row" *ngIf="selection.metaData.ATOSGradeEquivalent === 'NP'">
                <label for="poetryLevelATOS" class="col-form-label col-xs-5">Poetry Level (ATOS)</label>
                <div class="col-xs-3">
                    <input class="form-control" type="text" [(ngModel)]="selection.metaData.poetryLevel.ATOSGradeEquivalent"
                           id="poetryLevelATOS">
                </div>
                <label for="poetryLevelFP" class="col-form-label col-xs-5">Poetry Level (Fountas Pinnell)</label>
                <div class="col-xs-3">
                    <input class="form-control" type="text" [(ngModel)]="selection.metaData.poetryLevel.fountasPinnellLevel"
                           id="poetryLevelFP">
                </div>
                <label for="poetryLevelLexile" class="col-form-label col-xs-5">Poetry Level (Lexile)</label>
                <div class="col-xs-3">
                    <input class="form-control" type="text" [(ngModel)]="selection.metaData.poetryLevel.lexileLevel"
                           id="poetryLevelLexile">
                </div>
            </div>

            <div class="form-group row">
                <label for="lexileLevel" class="col-form-label col-xs-5">Lexile</label>
                <div class="col-xs-3">
                    <input class="form-control" type="text" [(ngModel)]="selection.metaData.lexileLevel"
                           id="lexileLevel">
                </div>
            </div>

            <div class="form-group row">
                <label for="fountasPinnellLevel" class="col-form-label col-xs-5">F & P</label>
                <div class="col-xs-3">
                    <input class="form-control" type="text" [(ngModel)]="selection.metaData.fountasPinnellLevel"
                           id="fountasPinnellLevel">
                </div>
            </div>

            <div class="form-group row">
                <label for="wordCount" class="col-form-label col-xs-5">Word Count</label>
                <div class="col-xs-3">
                    <input class="form-control" type="text" [(ngModel)]="selection.metaData.wordCount" id="wordCount">
                </div>
            </div>

            <div class="form-group row">
                <label for="wpmGoal" class="col-form-label col-xs-5">WPM Goal</label>
                <div class="col-xs-3">
                    <input class="form-control" type="text" [(ngModel)]="selection.metaData.wpmGoal" id="wpmGoal">
                </div>
            </div>
        </div>

        <div class="card-block">

            <div class="form-group row">
                <label for="contentVersion" class="col-form-label col-xs-3">Content Version</label>
                <div class="col-xs-9">
                    <input class="form-control" type="text" [(ngModel)]="selection.metaData.contentVersion" id="contentVersion">
                </div>
            </div>

            <div class="form-group row">
                <label for="introText" class="col-form-label col-xs-3">Text Intro</label>
                <div class="col-xs-9">
                    <textarea style='font-size: 11pt' name="introText" cols="44" rows="6" [(ngModel)]="selection.metaData.introText" id="introText"></textarea>
                    <!--<input class="form-control" type="text" [(ngModel)]="selection.metaData.introText" id="introText">-->
                </div>

            </div>

            <div class="form-group row">
                <label [attr.for]="creditAttribution" class="col-form-label col-xs-3">Credit Attribution</label>
                <div class="col-xs-9">
                    <textarea style='font-size: 11pt' name="creditAttribution" cols="44" rows="6" [(ngModel)]="creditAttribution" id="creditAttribution"></textarea>
                    <!--<input class="form-control" type="text" [(ngModel)]="selection.metaData.introText" id="introText">-->
                </div>

            </div>

            <div class="form-group row">
                <label [attr.for]="creditDescription" class="col-form-label col-xs-3">Credit Description</label>
                <div class="col-xs-9">
                    <textarea style='font-size: 11pt' name="creditDescription" cols="44" rows="6" [(ngModel)]="creditDescription" id="creditDescription"></textarea>
                    <!--<input class="form-control" type="text" [(ngModel)]="selection.metaData.introText" id="introText">-->
                </div>

            </div>

            <div class="form-group row">
                <label for="genre" class="col-form-label col-xs-3 mr-2">Genre</label>
                <select id="genre" [(ngModel)]="selection.metaData.genre">
                    <option disabled>{{dropdownDefault}}</option>
                    <option *ngFor="let genre of genreValues" value={{genre}}>
                        {{genre}}
                    </option>
                </select>
            </div>

            <div class="form-group row">
                <label for="protagonistGender" class="col-form-label col-xs-4">Protagonist Gender</label>
                <select id="protagonistGender" [(ngModel)]="selection.metaData.protagonistGender">
                    <option disabled>{{dropdownDefault}}</option>
                    <option *ngFor="let gender of protagonistGender" value={{gender}}>
                        {{gender}}
                    </option>
                </select>
            </div>

            <div class="form-group row">
                <label for="setting" class="col-form-label col-xs-3 mr-2">Setting</label>
                <select id="setting" [(ngModel)]="selection.metaData.setting">
                    <option disabled>{{dropdownDefault}}</option>
                    <option *ngFor="let setting of settings" value={{setting}}>
                        {{setting}}
                    </option>
                </select>
            </div>

            <div class="form-group row">
                <label for="authorRepresentation" class="col-form-label col-xs-3 mr-2">Author Representation</label>
                <ng-select class="custom" labelForId="authorRepresentation"
                           [items]="authorRepresentation"
                           bindLabel="name"
                           placeholder="Select"
                           appendTo="body"
                           [multiple]="true"
                           [clearable]="false"
                           [(ngModel)]="selection.metaData.authorRepresentation">
                </ng-select>

            </div>

            <div class="form-group row">
                <label for="characterRepresentation" class="col-form-label col-xs-3 mr-2">Character Representation</label>
                <ng-select class="custom" labelForId="characterRepresentation"
                           [items]="characterRepresentation"
                           bindLabel="name"
                           placeholder="Select"
                           appendTo="body"
                           [multiple]="true"
                           [clearable]="false"
                           [(ngModel)]="selection.metaData.characterRepresentation">
                </ng-select>

            </div>

            <div class="form-group row">
                <label for="contentExclusions" class="col-form-label col-xs-3 mr-2">Exclusions</label>
                <ng-select class="custom col-xs-6 mr-2 no-gutter" labelForId="contentExclusions"
                           [items]="exclusions"
                           bindLabel="name"
                           placeholder="Select"
                           appendTo="body"
                           [multiple]="true"
                           [clearable]="false"
                           [(ngModel)]="selection.metaData.exclusions">
                </ng-select>

            </div>

            <div class="form-group row">
                <label for="contentAreas" class="col-form-label col-xs-3 mr-2">Content Areas</label>
                <ng-select class="custom" labelForId="contentAreas"
                           [items]="contentAreas"
                           bindLabel="name"
                           placeholder="Select"
                           appendTo="body"
                           [multiple]="true"
                           [clearable]="false"
                           [(ngModel)]="selection.metaData.contentAreas">
                </ng-select>

            </div>

            <div class="form-group row">
                <label for="contentTags" class="col-form-label col-xs-3 mr-2">Content Tags</label>
                <ng-select class="custom" labelForId="contentTags"
                           [items]="contentTags"
                           bindLabel="name"
                           placeholder="Select"
                           appendTo="body"
                           [multiple]="true"
                           [clearable]="false"
                           [(ngModel)]="selection.metaData.contentTags">
                </ng-select>

            </div>

        </div>

        <div class="card-footer">
            <div class="btn-group pull-md-right">
                <button class="btn btn-success" [disabled]="saveInProgress" (click)="save()">Save
                </button>

            </div>
        </div>


    </div>
</div>
